module.exports = require('./reserved-words');



//////////////////
// WEBPACK FOOTER
// ./~/reserved-words/lib/index.js
// module id = 452
// module chunks = 0